import React from 'react';
import AparienciaData from '../../Components/Admin/AparienciaData/AparienciaData';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const Apariencia = () => {
  const { rol } = useSelector((state) => state.auth);

  if (rol !== 'admin') return <Navigate to="/" />;

  return <AparienciaData />;
};

export default Apariencia;
